<template>
  <div class="homecaredetail">
    <div class="homecare-container_ cen">
      <Breadcrumb>
        <BreadcrumbItem to="/">首页</BreadcrumbItem>
        <BreadcrumbItem :to="{ path: '/homecare/index', query: { cid: fid } }">居家养老</BreadcrumbItem>
        <BreadcrumbItem :to="{ path: '/homecare', query: { cid: pname.id } }">{{pname.classname}}</BreadcrumbItem>
        <BreadcrumbItem>{{currentClassName.title}}</BreadcrumbItem>
      </Breadcrumb>
      <div class="inside-main">
        <div class="homecare-detail">
          <div class="homecare-detail-img">
            <img :class="[ hasPic? '': 'nopic']"  :src="domainNameH5 + '/' + detailInfo.picurl" width="100%" alt="">
            <div class="">{{detailInfo.title}}</div>
          </div>
          <div class="homecare-detail-cont">
            <div class="homecare-detail-item">服务介绍</div>
            <div class="detail-cont" v-html="detailInfo.content"></div>
          </div>
        </div>
        <div class="inside-left-nav">
          <div class="left-nav-head">
            <div class="chname">{{fname.classname}}</div>
            <div class="enname">{{fname.classname_en}}</div>
          </div>
          <div class="left-nav-list">
            <div class="left-nav-li" v-for="item in getsort" :key="item.id" :class="[ item.id === cid ? 'active' : '']">
              <router-link :to="{ path: '/homecare', query: { cid: item.id } }" class="left-nav-link">
                <div class="chname">{{item.classname}}</div>
                <div class="enname">{{item.classname_en}}</div>
                <span></span>
              </router-link>
              <div class="left-subnav" v-if="item.sort_list">
                <div class="left-subnav-li" v-for="itemSort in item.sort_list" :key="itemSort.id" :class="[ itemSort.id === id ? 'active' : '']">
                  <router-link :to="{ path: '/homecare/detail', query: { cid: itemSort.classid, id: itemSort.id } }" class="left-subnav-link">{{itemSort.title}}</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="reserve-enter">
      <div class="reserve-enter_">
        <div class="reserve-enter-btn" @click="showReserveFrom">
          服务预约
          <div></div>
        </div>
      </div>
    </div>
    <apply-member></apply-member>

    <div class="popsbox">
      <div class="popsbox_">
        <div class="popsbox_close" @click="hideReserveFrom"></div>
        <div class="popsbox_head">服务预约</div>
        <div class="dialog-form">
          <div class="dialog-form-head">接受服务人</div>
          <div class="dialog-inputbox">
            <div class="dialog-item">姓名：</div>
            <div class="dialog-input">
              <div class="dialog-input_">
                <input type="text" v-model="reserveForm.reserveName" class="input" placeholder="填写入住人姓名">
              </div>
            </div>
          </div>
          <div class="dialog-inputbox">
            <div class="dialog-item">年龄：</div>
            <div class="dialog-input">
              <div class="dialog-input_">
                <input type="text" v-model="reserveForm.reserveAge" class="input" placeholder="请输入入住人年龄">
              </div>
            </div>
          </div>
          <div class="dialog-inputbox highbox">
            <div class="dialog-item">备注：</div>
            <div class="dialog-input">
              <div class="dialog-input_">
                <textarea v-model="reserveForm.reserveDesc" placeholder="请填写备注信息"></textarea>
              </div>
            </div>
          </div>
          <div class="dialog-form-head">联系人</div>
          <div class="dialog-inputbox">
            <div class="dialog-item">与入住人关系：</div>
            <div class="dialog-input">
              <div class="dialog-input_">
                <select v-model="reserveForm.relationship">
                  <option value="请选择">请选择</option>
                  <option v-for="(item, index) in relationList" :key="index" :value="item.dataname">{{item.dataname}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="dialog-inputbox">
            <div class="dialog-item">姓名：</div>
            <div class="dialog-input">
              <div class="dialog-input_">
                <input type="text" v-model="reserveForm.cantactName" class="input" placeholder="填写联系人姓名">
              </div>
            </div>
          </div>
          <div class="dialog-inputbox">
            <div class="dialog-item">手机号：</div>
            <div class="dialog-input">
              <div class="dialog-input_">
                <input type="text" maxlength="11" v-model="reserveForm.cantact" class="input" placeholder="填写联系人的手机号">
              </div>
            </div>
          </div>
          <div v-if="getUserId==''">
            <div class="dialog-inputbox">
              <div class="dialog-item">用户名：</div>
              <div class="dialog-input">
                <div class="dialog-input_">
                  <input type="text" v-model="reserveForm.username" class="input" placeholder="填写用户名">
                </div>
              </div>
            </div>
            <div class="dialog-inputbox">
              <div class="dialog-item">登录密码：</div>
              <div class="dialog-input">
                <div class="dialog-input_">
                  <input type="password" v-model="reserveForm.password" class="input" placeholder="填写您的登录密码">
                </div>
              </div>
            </div>
            <div class="dialog-tip">※&nbsp;&nbsp;完成预约的同时您将成为我们的会员，你可直接在个人账户中查看预约进度</div>
            <div class="rememberbox">
              <label for="remember">
                <input type="checkbox" v-model="remember" id="remember">勾选同意《<router-link to="/agreement" target="_blank">用户服务协议</router-link>》
              </label>
            </div>
          </div>
          <div class="dialog-btn" @click="submitForm">确认提交</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setToken } from '../../utils/auth'
import store from '../../store/index'
import { mapGetters } from 'vuex'
import { getHeaderData, getHomeCareDetailData, addService, registerService, getRelationData } from '../../api/getData.js'
import { validateUserName, validatePassword, validateMobile } from '../../assets/js/validate.js'
import ApplyMember from '../../components/applyMember'
export default {
  name: 'homeCareDetail',
  components: {
    ApplyMember
  },
  data () {
    return {
      headerInfo: {},
      fid: '',
      cid: '',
      id: '',
      pname: '',
      currentClassName: '',
      fname: {},
      getsort: [],
      detailInfo: {},
      relationList: [],
      reserveForm: {
        reserveName: '',
        reserveAge: '',
        reserveDesc: '',
        relationship: '请选择',
        cantactName: '',
        cantact: '',
        username: '',
        password: ''
      },
      remember: false,
      hasPic: false
    }
  },
  computed: {
    ...mapGetters([
      'getUserId'
    ])
  },
  metaInfo () {
    return {
      title: this.headerInfo.title,
      meta: [
        { name: 'generator', content: this.headerInfo.generator },
        { name: 'author', content: this.headerInfo.author },
        { name: 'keywords', content: this.headerInfo.keywords },
        { name: 'description', content: this.headerInfo.description }
      ]
    }
  },
  watch: {
    '$route': function () {
      this.cid = this.$route.query.cid === undefined ? '' : this.$route.query.cid
      this.id = this.$route.query.id === undefined ? '' : this.$route.query.id
      this.getHeaderInfo()
      this.getHomeCareDetailInfo()
    }
  },
  created () {
    this.cid = this.$route.query.cid === undefined ? '' : this.$route.query.cid
    this.id = this.$route.query.id === undefined ? '' : this.$route.query.id
    this.getHeaderInfo()
    this.getRelationInfo()
    this.getHomeCareDetailInfo()
  },
  methods: {
    async getHeaderInfo () {
      let postData = { cid: this.cid, id: this.id }
      let header = await getHeaderData(postData)
      this.headerInfo = header.header
      this.$store.dispatch('SetActiveMenu', { activeMenu: 'homecare', activeSendMenu: this.cid }).then(() => {}).catch(() => {})
    },
    async getRelationInfo () {
      let result = await getRelationData()
      this.relationList = result.relation
    },
    async getHomeCareDetailInfo () {
      let postData = {}
      postData.fid = this.fid
      postData.cid = this.cid
      postData.id = this.id
      let result = await getHomeCareDetailData(postData)
      this.cid = result.cid
      this.id = result.id
      this.pname = result.pname
      this.currentClassName = result.cname
      this.fname = result.fname
      this.getsort = result.home_care
      this.detailInfo = result.info
      this.hasPic = result.info.picurl !== '' ? true : false
    },
    showReserveFrom () {
      window.$('body').css({
        'overflow': 'hidden'
      })
      window.$('.popsbox').stop().fadeIn(500)
    },
    hideReserveFrom () {
      window.$('body').css({
        'overflow': 'auto'
      })
      window.$('.popsbox').stop().fadeOut(500)
    },
    async submitForm () {
      if (this.verification()) {
        let postData = {}
        postData.title = this.currentClassName.title
        postData.service_name = this.reserveForm.reserveName
        postData.age = this.reserveForm.reserveAge
        postData.remark = this.reserveForm.reserveDesc
        postData.relation = this.reserveForm.relationship
        postData.contact_name = this.reserveForm.cantactName
        postData.phone_num = this.reserveForm.cantact
        postData.service_type = '居家'
        if (this.getUserId === '') {
          postData.username = this.reserveForm.username
          postData.password = this.encrypt(this.reserveForm.password)
          let result = await registerService(postData)
          if (result.code === '1') {
            store.commit('SET_USERID', result.userinfo.user_id)
            store.commit('SET_USER', result.userinfo.username)
            setToken('userId', result.userinfo.user_id)
            setToken('username', result.userinfo.username)
            this.message('提交成功', true)
          } else {
            this.message('提交失败')
          }
        } else {
          postData.id = this.getUserId
          let result = await addService(postData)
          if (result.code === '1') {
            this.message('提交成功', true)
          } else {
            this.message('提交失败')
          }
        }
      }
    },
    verification () {
      if (this.reserveForm.reserveName === '') {
        this.message('请输入入住人姓名')
        return false
      }
      if (this.reserveForm.reserveAge === '') {
        this.message('请输入入住人年龄')
        return false
      }
      if (this.reserveForm.reserveDesc === '') {
        this.message('请输入备注')
        return false
      }
      if (this.reserveForm.relationship === '请选择') {
        this.message('请选择与入住人关系')
        return false
      }
      if (this.reserveForm.cantactName === '') {
        this.message('请输入联系人姓名')
        return false
      }
      if (this.reserveForm.cantact === '') {
        this.message('请输入联系人的手机号')
        return false
      }
      if (!validateMobile(this.reserveForm.cantact)) {
        this.message('联系人手机号格式不正确')
        return false
      }
      if (this.getUserId === '' && this.reserveForm.username === '') {
        this.message('请输入用户名称')
        return false
      }
      if (this.getUserId === '' && !validateUserName(this.reserveForm.username)) {
        this.message('请输入中文或英文,长度2~10位')
        return false
      }
      if (this.getUserId === '' && this.reserveForm.password === '') {
        this.message('请输入登录密码')
        return false
      }
      if (this.getUserId === '' && !validatePassword(this.reserveForm.password)) {
        this.message('密码长度6~20位，且同时包含数字、字母')
        return false
      }
      if (this.getUserId === '' && !this.remember) {
        this.message('请阅读用户服务协议，并同意')
        return false
      }
      return true
    },
    encrypt (pwd) {
      let pubkey = '-----BEGIN PUBLIC KEY-----'
      pubkey += 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAqtcivu827OwO3XQZPpjI'
      pubkey += 'xv3sf3ar0wYkjk6k2XeYJVhyUmqR8r5tpsiLsUhsXwAEA0hjPLkVGHx6ms9A9Tbd'
      pubkey += 'PAji3/WygeCb3SwB3dK85thQlNfGmOS/dtxaUguWU1bZDHN0xldJEVzQFdzpRtce'
      pubkey += 'rTRLyZnYc/SVhUdlhORKDgfu7+ZsH2Xwi8gO3LdqABeukeqqOqnmEtxRIzVWNJsV'
      pubkey += '6TR+2exwxlS5D6B7jEOmBUCvGsNi7xBaQYgXg8aH87CP4pNdueBvCDAIB5oB6zVg'
      pubkey += 'mrVxG909H8pKMZp+4A0AmjXOgTzEhnZ5dB2WHUZT1XvC8CugW/T5U2AX9x0am1+5'
      pubkey += 'aQIDAQAB'
      pubkey += '-----END PUBLIC KEY-----'
      let encrypt = new JSEncrypt()
      encrypt.setPublicKey(pubkey)
      let encrypted = encrypt.encrypt(JSON.stringify({ 'encrypt': 'yes', 'password': pwd }))
      return encrypted
    },
    message (content, status) {
      this.$alert(content, '提示', {
        confirmButtonText: '确定',
        callback: action => {
          if (status) {
            window.location.reload()
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
  .homecare-detail{
    width: 77.22%;
    padding: 0 30px;
    background-color: #ffffff;
    box-shadow: 0px 0px 13px 0px rgba(37, 37, 37, 0.15);
    border-radius: 5px;
    .homecare-detail-img{
      min-height: 290px;
      position: relative;
      .nopic{
        display: none;
      }
      div{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 630px;
        padding: 20px 10px;
        border-radius: 45px;
        background-color: rgba(75,123,190,0.5);
        font-size: 36px;
        line-height: 50px;
        text-align: center;
        color: #ffffff;
      }
    }
    .homecare-detail-cont{
      padding: 0 45px 80px;
      .homecare-detail-item{
        border-left: 4px solid #e76321;
        margin-top: 60px;
        margin-left: 10px;
        padding-left: 20px;
        font-size: 36px;
        line-height: 36px;
        color: #e76321;
        font-weight: bold;
      }
      .detail-cont{
        margin-top: 30px;
        font-size: 24px;
        line-height: 42px;
        text-align: justify;
        color: #333333;
        word-break: break-all;
      }
    }
  }
  .reserve-enter{
    overflow: hidden;
    .reserve-enter_{
      position: relative;
      float: right;
      width: 72.4%;
      height: 190px;
      margin: 70px 0 50px;
      border-top-left-radius: 96px;
      border-bottom-left-radius: 96px;
      background-image: url("../../assets/images/reserve.png");
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      .reserve-enter-btn{
        position: absolute;
        left: 29.5%;
        top: 50%;
        transform: translateY(-50%);
        width: 400px;
        height: 90px;
        border-radius: 45px;
        background-color: #4b7bbe;
        font-size: 36px;
        line-height: 90px;
        text-align: center;
        color: #ffffff;
        font-weight: bold;
        cursor: pointer;
        div{
          position: absolute;
          left: 0;
          top: 0;
          width: 90px;
          height: 90px;
          border-radius: 50%;
          box-shadow: 0px 0px 11.57px 1.43px rgba(0, 0, 0, 0.1);
          background-image: url("../../assets/images/icons.png");
          background-repeat: no-repeat;
          background-position: 24px -683px;
        }
      }
    }
  }
  .popsbox{
    display: none;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background-color: rgba(0,0,0,0.7);
    overflow-y: scroll;
    .popsbox_{
      position: absolute;
      top: 100px;
      left: 50%;
      transform: translateX(-50%);
      width: 960px;
      margin-bottom: 100px;
      padding-bottom: 110px;
      border-radius: 12px;
      background-color: #ffffff;
      background-image: url("../../assets/images/reserve-bg.png");
      background-repeat: no-repeat;
      background-position: center top;
      .popsbox_close{
        position: absolute;
        top: 20px;
        right: 20px;
        width: 28px;
        height: 28px;
        background-image: url("../../assets/images/icons.png");
        background-repeat: no-repeat;
        background-position: 0 -450px;
        cursor: pointer;
        transition: transform 0.5s ease 0s;
        &:hover{
          transform: rotate(180deg);
        }
      }
      .popsbox_head{
        padding: 134px 0;
        font-size: 36px;
        line-height: 40px;
        text-align: center;
        color: #ffffff;
      }
      .dialog-form-head{
        margin-bottom: 25px;
        font-size: 30px;
        line-height: 50px;
        text-align: center;
        color: #50c9c3;
      }
      .dialog-inputbox{
        height: 65px;
        margin-bottom: 30px;
        &.highbox{
          height: 170px;
        }
        .dialog-item{
          float: left;
          width: 28.75%;
          padding-right: 10px;
          font-size: 24px;
          line-height: 65px;
          text-align: right;
          color: #333333;
        }
        .dialog-input{
          position: relative;
          float: left;
          width: 71.25%;
          height: 40px;
          .dialog-input_{
            position: relative;
            width: 86.25%;
            .input{
              width: 100%;
              padding: 0 30px;
              border-radius: 32px;
              box-shadow: 0px 0px 18px 0px rgba(37, 37, 37, 0.15);
              font-size: 18px;
              line-height: 65px;
              color: #666666;
            }
            textarea{
              width: 100%;
              height: 170px;
              border-radius: 5px;
              box-shadow: 0px 0px 18px 0px rgba(37, 37, 37, 0.15);
              padding: 0 30px;
              font-size: 18px;
              line-height: 65px;
              color: #666666;
              resize: none;
            }
            select{
              width: 100%;
              height: 65px;
              border: none;
              border-radius: 32px;
              background: url('../../assets/images/select-2.png') no-repeat right center;
              box-shadow: 0px 0px 18px 0px rgba(37, 37, 37, 0.15);
              padding: 0 30px;
              font-size: 18px;
              line-height: 65px;
              color: #666666;
              appearance: none;
              outline: none;
            }
          }
        }
      }
      .dialog-btn{
        width: 480px;
        height: 80px;
        border-radius: 40px;
        background-color: #ec6420;
        margin: 75px auto 0;
        font-size: 30px;
        line-height: 80px;
        text-align: center;
        color: #ffffff;
        cursor: pointer;
      }
      .dialog-tip{
        padding-left: 17.7%;
        font-size: 18px;
        line-height: 30px;
        color: #666666;
      }
      .rememberbox{
        padding-left: 17.7%;
        margin-top: 12px;
        font-size: 18px;
        line-height: 20px;
        color: #50c9c3;
        a{
          color: #50c9c3;
        }
        input[type='checkbox']{
          float: left;
          width: 14px;
          height: 14px;
          border-radius: 50%;
          margin: 3px 10px 0 0;
          background-image: url("../../assets/images/icons.png");
          background-repeat: no-repeat;
          background-size: 322px auto;
          background-position: -245px 0;
          appearance: none;
          &:checked{
            background-image: url("../../assets/images/check_cur.png");
            background-repeat: no-repeat;
            background-size: 14px auto;
            background-position: 0 0;
          }
        }
      }
    }
  }

  @media screen and (max-width: 1300px){
    .homecare-detail{
      .homecare-detail-img{
        div{
          width: 520px;
        }
      }
      .homecare-detail-cont{
        padding: 0 20px 80px;
        .homecare-detail-item{
          margin-top: 30px;
        }
      }
    }
  }
  @media screen and (max-width: 1200px){
    .homecare-detail{
      width: 100%;
      margin-bottom: 20px;
      padding: 0 15px;
      border-radius: 3px;
      .homecare-detail-img{
        div{
          width: 80%;
          padding: 10px 5px;
          border-radius: 22px;
          font-size: 18px;
          line-height: 25px;
        }
      }
      .homecare-detail-cont{
        padding: 0 0 40px;
        .homecare-detail-item{
          border-left: 2px solid #e76321;
          margin-top: 30px;
          margin-left: 5px;
          padding-left: 10px;
          font-size: 18px;
          line-height: 18px;
        }
        .detail-cont{
          margin-top: 15px;
          font-size: 12px;
          line-height: 21px;
        }
      }
    }
    .reserve-enter{
      .reserve-enter_{
        position: relative;
        float: right;
        width: 80%;
        height: 95px;
        margin: 35px 0 25px;
        border-top-left-radius: 48px;
        border-bottom-left-radius: 48px;
        .reserve-enter-btn{
          position: absolute;
          left: 20%;
          width: 200px;
          height: 45px;
          border-radius: 22px;
          font-size: 18px;
          line-height: 45px;
          div{
            width: 45px;
            height: 45px;
            background-size: 230px auto;
            background-position: 12px -341px;
          }
        }
      }
    }
    .popsbox{
      .popsbox_{
        top: 50px;
        left: 10px;
        right: 10px;
        transform: none;
        width: auto;
        margin-bottom: 50px;
        padding-bottom: 55px;
        padding-left: 20px;
        padding-right: 20px;
        border-radius: 6px;
        background-size: 100% auto;
        .popsbox_close{
          top: 10px;
          right: 10px;
          width: 14px;
          height: 14px;
          background-size: 230px auto;
          background-position: 0 -225px;
        }
        .popsbox_head{
          padding: 60px 0;
          font-size: 18px;
          line-height: 20px;
        }
        .dialog-form-head{
          margin-bottom: 0;
          font-size: 15px;
          line-height: 25px;
        }
        .dialog-inputbox{
          height: auto;
          margin-bottom: 15px;
          &.highbox{
            height: auto;
            .dialog-input{
              height: 85px;
            }
          }
          .dialog-item{
            float: none;
            width: 100%;
            padding-right: 0;
            font-size: 14px;
            line-height: 32px;
            text-align: left;
          }
          .dialog-input{
            float: none;
            width: 100%;
            height: 32px;
            .dialog-input_{
              position: relative;
              width: 100%;
              .input{
                width: 100%;
                padding: 0 15px;
                border-radius: 16px;
                font-size: 12px;
                line-height: 32px;
              }
              textarea{
                width: 100%;
                height: 85px;
                border-radius: 3px;
                padding: 0 15px;
                font-size: 12px;
                line-height: 32px;
              }
              select{
                height: 32px;
                border-radius: 16px;
                background-size: auto 32px;
                padding: 0 15px;
                font-size: 12px;
                line-height: 32px;
              }
            }
          }
        }
        .dialog-btn{
          width: 100%;
          height: 40px;
          border-radius: 20px;
          margin: 35px auto 0;
          font-size: 15px;
          line-height: 40px;
        }
        .dialog-tip{
          padding-left: 0;
          font-size: 12px;
          line-height: 18px;
        }
        .rememberbox{
          padding-left: 0;
          margin-top: 12px;
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
  }
</style>
<style lang="less">
  .detail-cont{
    img,iframe,video{
      max-width: 100%;
    }
  }
</style>
